<template>
    <performance-common-dialog
        :title="'按运单装车页面'"
        ref="performanceCommonDialog"
        @close="dialogClose"
        :width="'400px'"
    >
        <template #top>
            <el-form
                class="form-container"
                ref="formRef"
                label-width="100px"
                :model="config.form"
                :rules="config.rules"
            >
                <el-form-item label="运输单号：" prop="taskNo">
                    <el-input v-model="config.form.taskNo" disabled></el-input>
                </el-form-item>
                <el-form-item label="装车时间：" prop="loadDate">
                    <el-date-picker
                        v-model="config.form.loadDate"
                        type="datetime"
                        placeholder="选择日期时间"
                    >
                    </el-date-picker>
                </el-form-item>
                <div class="footer-bottom">
                    <el-button
                        type="primary"
                        @click="taskNoLoading"
                        :loading="loading"
                    >
                        按运单装车
                    </el-button>
                </div>
            </el-form>
        </template>
    </performance-common-dialog>
</template>
<script>
import dayjs from 'dayjs';
import { config } from './config.js';
import PerformanceCommonDialog from '@/modules/transport/otp/components/PerformanceCommonDialog';
import { saveTransportLoadInfo } from '@/modules/transport/otp/api/performanceDispatchMgmtNew.js';

export default {
    name: 'dispatchArrivalRegistration',
    components: { PerformanceCommonDialog },
    props: {
        componentsModalData: {
            type: Object,
            default () {
                return {};
            }
        }
    },
    data () {
        return {
            config: config,
            loading: false
        };
    },
    mounted () {
        this.config.form.loadDate = '';
        this.config.form.taskNo = this.componentsModalData.taskNo;
        this.$refs.performanceCommonDialog.show();
    },
    methods: {
        /**
         * @description 运单装车
        */
        async taskNoLoading () {
            const { validate } = this.$refs.formRef;
            const { loadDate, taskNo } = this.config.form;
            await validate();
            this.loading = true;
            saveTransportLoadInfo({
                taskNo: taskNo,
                loadDate: dayjs(loadDate).format('YYYY-MM-DD HH:mm:ss')
            }).then((res) => {
                if (res && +res.code === 0) {
                    this.$message.success(res.msg || '操作成功');
                    this.dialogClose();
                }
            }).finally(() => {
                this.loading = false;
            });
        },
        dialogClose () {
            this.$emit('components-close');
        }
    }

};
</script>

<style scoped lang="less">
.footer-bottom {
    display: flex;
    justify-content: flex-end;
    margin: 10px 0;
}
/deep/.el-input {
    width: 260px;
}
/deep/.el-form-item__label {
    color: #999;
}
/deep/.el-form-item__content {
    color: #333;
}
</style>
